














import Vue from 'vue';
import FetchHelper from '../../../helpers/OldFetchHelper';
import SelectInput from './SelectInput.vue';

const cache: Record<string, unknown> = {};

interface IRemoteDataSelectInputComponent {
  itemData: unknown[];
}

export default Vue.extend({
  components: {
    SelectInput,
  },
  model: {
    event: `change`,
    prop: `value`,
  },
  data(): IRemoteDataSelectInputComponent {
    return {
      itemData: [],
    };
  },
  computed: {
    itemOptions(): { text: string; value: string }[] {
      // c is from type unknown, therefore a direct member access is not possible according to ts
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return this.itemData.map((c: unknown) => { return { text: c[this.textProperty], value: c[this.valueProperty] }; });
    },
  },
  props: {
    identifier: {
      default: ``,
      type: String,
    },
    path: {
      required: true,
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    showEmptyOption: {
      default: false,
      type: Boolean,
    },
    showError: {
      default: false,
      type: Boolean,
    },
    t: {
      required: true,
      type: Object as () => Record<string, string>,
    },
    testSelector: {
      default: ``,
      type: String,
    },
    textProperty: {
      required: true,
      type: String,
    },
    title: {
      default: ``,
      type: String,
    },
    transformer: {
      default: null,
      type: Function,
    },
    value: {
      required: true,
      type: [String, Number],
    },
    valueProperty: {
      required: true,
      type: String,
    },
  },
  mounted(): void {
    this.loadItems();
  },
  /* eslint-disable @typescript-eslint/ban-ts-comment */
  methods: {
    async loadItems(): Promise<void> {
      if(!cache[this.path] || (cache[this.path] as unknown[]).length === 0) {
        const response = await FetchHelper.get({ path: this.path });
        if(response.success) {
          cache[this.path] = this.transformer ? this.transformer(response.data) : response.data;
        } else {
          this.$swal(``, response.message, `warning`);
        }
      }
      this.itemData = cache[this.path] as unknown[];
      // c is from type unknown, therefore a direct member access is not possible according to ts
      // @ts-ignore
      this.$emit(`itemChanged`, this.itemData.find(c => c[this.valueProperty] === this.value));
    },
    onItemChanged(event: string): void {
      this.$emit(`change`, event);
      // c is from type unknown, therefore a direct member access is not possible according to ts
      // @ts-ignore
      this.$emit(`itemChanged`, this.itemData.find(c => c[this.valueProperty] === event));
    },
    /* eslint-enable @typescript-eslint/ban-ts-comment */
  },
});
